module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt5"
  }, _vm._l((_vm.filter.options), function(option, index) {
    return _c('span', {
      staticClass: "mr20"
    }, [_c('NbCheckbox', {
      attrs: {
        "val": option.value
      },
      model: {
        value: (_vm.filter.value),
        callback: function($$v) {
          _vm.$set(_vm.filter, "value", $$v)
        },
        expression: "filter.value"
      }
    }), _vm._v(" "), _c('span', {
      class: 'label label-' + option.style
    }, [_vm._v(_vm._s(option.name))])], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-d0f17028"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/common/widget/filter/NbFilterMultiSelection.vue
// module id = 1027
// module chunks = 1